<template>
  <article v-scroll:reveal class="layout-cta -bottom">
    <section class="layout-cta__box -accent">
      <BranchShape v-scroll:reveal="{ delay: 125 }" class="layout-cta__branch" color="white" opacity="0.1" />

      <div v-scroll:reveal="{ delay: 75 }" class="layout-cta__content">
        <h4 class="layout-section__heading">Section d’appel à l’action</h4>
        <p>
          Cette zone visuellement distincte attire l’attention et marque une pause dans la navigation. Elle met de
          l’avant une action importante à accomplir et vise à maximiser l’engagement des visiteurs.
        </p>
      </div>

      <button v-scroll:reveal="{ delay: 175 }" class="layout-cta__button">
        <SvgIcon id="action-arrow" />
      </button>
    </section>
  </article>
</template>

<script>
export default {
  name: 'DemoCta'
}
</script>
